import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=91cdb8d0&"
import script from "./HeaderSection.vue?vue&type=script&lang=js&"
export * from "./HeaderSection.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=91cdb8d0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91cdb8d0')) {
      api.createRecord('91cdb8d0', component.options)
    } else {
      api.reload('91cdb8d0', component.options)
    }
    module.hot.accept("./HeaderSection.vue?vue&type=template&id=91cdb8d0&", function () {
      api.rerender('91cdb8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderSection.vue"
export default component.exports